/**
 * useReferralLinks Hook
 *
 * React Query hook for fetching referral links.
 */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getReferralLinks, createReferralLink } from "@/lib/api/referral";

export const REFERRAL_LINKS_KEY = ["referral", "links"];

/**
 * Fetch referral links for workspace
 */
export function useReferralLinks() {
  return useQuery({
    queryKey: REFERRAL_LINKS_KEY,
    queryFn: async () => {
      const data = await getReferralLinks();
      return data.links;
    },
  });
}

/**
 * Create new referral link with optimistic update
 */
export function useCreateReferralLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createReferralLink,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: REFERRAL_LINKS_KEY });
    },
  });
}
